<template>
	<div class="container-fluid card-tela-principal d-flex flex-column fill-height">
		<v-card tile elevation="1" class="stick-bar">
			<v-row class="justify-space-between align-center ma-0 pa-2">
				<!-- TITLE -->
				<v-flex shrink class="mt-1 d-flex flex-column" style="min-width: 220px">
					<span class="title-programacao">
						Planejamento de Alojamento
					</span>
					<span class="title-programacao">
						#{{ planejamentoAlojamento.nrPlanejamentoAlojamento }}
					</span>
				</v-flex>

				<!--  TABS  -->
				<v-flex grow class="mt-1 d-flex justify-center">
					<!--    TABS    -->
					<div>
					<v-tabs v-model="tab" align-with-title slider-color="primary" :show-arrows="false">
						<v-tab class="font-size-08" @click="$router.replace('/planejamentoAlojamento')">Semana</v-tab>
						<v-tab :class="[{ 'btn-laranja': planejamentoAlojamento.cdStatusPlanejamentoAlojamento === 1 }]"
						       class="font-size-08"
						       @click="setarRota('preAlojamento')">
							Pré-Alojamento
						</v-tab>
						<v-tab
								:class="[{ 'btn-laranja': planejamentoAlojamento.cdStatusPlanejamentoAlojamento === 2 }]"
								class="font-size-08"
								@click="setarRota('creches')"
						>
							Creches
						</v-tab>
						<v-tab
								:class="[{ 'btn-laranja': planejamentoAlojamento.cdStatusPlanejamentoAlojamento === 3 }]"
								class="font-size-08"
								@click="setarRota('disponibilidade')"
						>
							Disponibilidade
						</v-tab>
						<v-tab
								:class="[{ 'btn-laranja': planejamentoAlojamento.cdStatusPlanejamentoAlojamento === 4 }]"
								class="font-size-08"
								@click="setarRota('alojamento')"
						>
							Alojamento
						</v-tab>
					</v-tabs>
					</div>
				</v-flex>

				<!--  AÇÕES  -->
				<v-flex shrink class="mt-1 ml-auto" style="min-width: 220px">
					<v-row justify="end" class="ma-0">
						<div v-show="btnCancelar.show">
							<v-btn color="secondary" @click="cancelarAlteracao">
								{{ btnCancelar.texto }}
							</v-btn>
						</div>
						<div class="d-flex justify-center ml-2">
							<v-btn color="primary" @click="confirmarAlteracao"
							       :loading="btnConfirmar.acao || btnConfirmar.texto === ''"
							       :disabled="btnConfirmar.disable">
								{{ btnConfirmar.texto }}
							</v-btn>
						</div>
					</v-row>
				</v-flex>
			</v-row>
		</v-card>

		<!--    TELA PRINCIPAL   -->
		<div class="fill-height">
			<router-view :btnCancelar.sync="btnCancelar" :btnConfirmar.sync="btnConfirmar"
                   @proximaEtapa="proximaEtapa($event)"
			             :planejamentoAlojamento="planejamentoAlojamento" :key="$route.fullPath" />
		</div>
	</div>
</template>

<script>
import { statusRoutes } from "../resources";

export default {
	name: "DetalhePlanejamentoAlojamento",
	data: () => ({
		tab: null,
		btnCancelar: {
			show: false,
			texto: null,
			acao: false,
		},
		btnConfirmar: {
			disable: true,
			texto: 'Confirmar',
			acao: false,
			acaoType: ''
		},
		planejamentoAlojamento: {cdStatusPlanejamentoAlojamento: 0},
		statusTypes: {},
	}),
	methods: {
		confirmarAlteracao() {
				this.btnConfirmar.acao = true
		},
		cancelarAlteracao() {
			this.btnCancelar.acao = true
		},
		proximaEtapa(etapa) {
			this.btnConfirmar.acao = false

			const indexEtapaAtual = this.statusTypes.findIndex(status => status['idStatusPlanejamentoAlojamento'] ===
					this.planejamentoAlojamento['cdStatusPlanejamentoAlojamento'])

			let idProximaEtapa = etapa ? etapa : this.statusTypes[indexEtapaAtual - 1]['idStatusPlanejamentoAlojamento']

			const payload = {
				cdStatusPlanejamentoAlojamento: idProximaEtapa,
				cdPlanejamentoAlojamento: this.$route.params.id,
			}

			this.$axios.post('/planejamento-alojamento-status/', payload)
					.then(res => {
              if (!res.data) return
              if (!res.data[0].data) return

              this.planejamentoAlojamento.cdStatusPlanejamentoAlojamento = parseInt(res.data[0].data.cdStatusPlanejamentoAlojamento)
              this.tab = idProximaEtapa > 4 ? 4 : idProximaEtapa
						}
					)
					.catch(error => {
						this.$store.commit("setSnack", {type: "error", msg: error});
					})
					.finally(() => {
						if(idProximaEtapa === 5) this.setarRota(statusRoutes[9])
						else this.setarRota(statusRoutes[idProximaEtapa])
					})
		},
		loadPlanejamento() {
			this.$axios.get('planejamento-alojamento/' + this.$route.params.id)
					.then((res) => {
						if (!res.data) return
						if (!res.data[0].data) return

						this.planejamentoAlojamento = res.data[0].data;

						this.tab = parseInt(_.findKey(statusRoutes, (value) => value === this.$route.name))
					})
					.catch(error => {
						this.$store.commit("setSnack", {type: "error", msg: error})
						this.$router.replace({name: 'planejamentoAlojamento'})
					})
		},
		loadTiposStatus() {
			this.$axios("status-planejamento-alojamento/")
					.then((res) => {
						if (!res.data) return
						if (!res.data[0].data) return

						this.statusTypes = res.data[0].data
					})
					.catch(error => {
						this.$store.commit("setSnack", {type: "error", msg: error});
					})
		},
		setarRota(rota) {
			if (this.$route.name !== rota) this.$router.push({
				name: rota,  params: { id: this.$route.params.id }
			})
		}
	},
	mounted() {
		this.loadTiposStatus()
		this.loadPlanejamento()
	}
};
</script>

<style lang="scss">
@import "../sass/common";

.stick-bar {
  position: sticky !important;
  top: 48px !important;
  left: 0 !important;
  z-index: 4;
}
</style>
